export function createTaloToimikuntaPosts(message, contact, yearClock, tasks) {

    let taloToimikunta = []

    if (tasks) {
        taloToimikunta.push({
            "id": "t1",
            "title": "TEHTÄVÄT",
            "content": tasks
        })
    }

    if (yearClock) {
        taloToimikunta.push({
            "id": "t2",
            "title": "VUOSIKELLO",
            "content": yearClock
        })
    }

    if (message) {
        taloToimikunta.push({
            "id": "t3",
            "title": "ESITTELY",
            "content": message
        })
    }

    if (contact) {
        taloToimikunta.push({
            "id": "t4",
            "title": "YHTEYSTIEDOT",
            "content": contact
        })
    }

    return taloToimikunta
}